"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderLegRef = exports.OrderLeg = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_keystone_1 = require("mobx-keystone");
var moment_1 = __importDefault(require("moment"));
var load_1 = require("../constants/load");
var api = __importStar(require("../services/api"));
var firebase_1 = __importDefault(require("../services/firebase"));
var models_1 = require("../utils/models");
var ETA_1 = require("./ETA");
var Load_1 = require("./Load");
var LoadDocument_1 = require("./LoadDocument");
var LoadStop_1 = require("./LoadStop");
var Truck_1 = require("./Truck");
var User_1 = require("./User");
var OrderLeg = /** @class */ (function (_super) {
    __extends(OrderLeg, _super);
    function OrderLeg() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return "".concat(_this.id); };
        _this.etaTracker = null;
        // onAttachedToRootStore() {
        //   console.log('on attached to root store orderleg');
        //   this.scheduleUpdateETA();
        //   const disposer = observe(this, 'statusEta', this.scheduleUpdateETA);
        //   return () => {
        //     disposer();
        //     this.clearUpdateETA();
        //   };
        // }
        _this.scheduleUpdateETA = function () {
            console.log('scheduled Update ETA observer');
            _this.clearUpdateETA();
            if (!_this.isActive) {
                return;
            }
            _this.updateETAs(true);
            _this.etaTracker = setInterval(function () {
                console.log('calling updateETAs from etaTracker...');
                if (!_this.isActive) {
                    _this.clearUpdateETA();
                }
                _this.updateETAs();
            }, ETA_1.ETA_INTERVAL + Math.random() * 1000);
        };
        _this.clearUpdateETA = function () {
            if (!_this.etaTracker) {
                return;
            }
            clearInterval(_this.etaTracker);
        };
        // get billOfLadingNumber() {
        //   return this.order.isValid ? this.order.current.billOfLadingNumber : '';
        // }
        _this.isPickupLocation = function (location) {
            return _this.pickupLocation &&
                _this.pickupLocation.isValid &&
                _this.pickupLocation.current === location;
        };
        _this._getDocument = function (documentType, documents) {
            return documents.find(function (document) { return document.documentType === documentType; });
        };
        _this.getDocument = function (documentType) {
            return _this._getDocument(documentType, Array.from(_this.documents));
        };
        _this.getDocumentForCarousel = function (documentType) {
            var document = _this.getDocument(documentType);
            if (document) {
                return document.photos
                    .filter(function (photo) { return !!photo.photo; })
                    .sort(function (a, b) { return Number(a.id) - Number(b.id); })
                    .map(function (photo) { return ({
                    id: photo.id,
                    src: photo.photo.fullSize,
                    thumbnail: photo.photo.thumbnail || '',
                    width: photo.width || 0,
                    height: photo.height || 0,
                    rotate: photo.rotate || 0,
                }); });
            }
            return [];
        };
        _this.getDocumentForFiles = function (documentType) {
            var document = _this.getDocument(documentType);
            if (document) {
                return document.files.map(function (file) { return ({
                    id: file.id,
                    file: file.file,
                    name: file.file.split('/').at(-1),
                }); });
            }
            return [];
        };
        _this.updateDwellTime = (0, mobx_keystone_1._async)(function (status) {
            var rootStore, entities, error_1, dropoffArrivedOnDwell, dropoffDepartedOnDwell, pickupArrivedOnDwell, pickupDepartedOnDwell;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/];
                        entities = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.driverUpdateDwellTime(rootStore.token, this.id, {
                                status: status,
                            })];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('[DEBUG] error', error_1.message);
                        return [3 /*break*/, 4];
                    case 4:
                        if (entities) {
                            dropoffArrivedOnDwell = entities.dropoffArrivedOnDwell, dropoffDepartedOnDwell = entities.dropoffDepartedOnDwell, pickupArrivedOnDwell = entities.pickupArrivedOnDwell, pickupDepartedOnDwell = entities.pickupDepartedOnDwell;
                            if (dropoffArrivedOnDwell) {
                                this.dropoffArrivedOnDwell = dropoffArrivedOnDwell;
                            }
                            if (dropoffDepartedOnDwell) {
                                this.dropoffDepartedOnDwell = dropoffDepartedOnDwell;
                            }
                            if (pickupArrivedOnDwell) {
                                this.pickupArrivedOnDwell = pickupArrivedOnDwell;
                            }
                            if (pickupDepartedOnDwell) {
                                this.pickupDepartedOnDwell = pickupDepartedOnDwell;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
        _this.getAllPaperworks = (0, mobx_keystone_1._async)(function () {
            var rootStore, entities, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.getAllPaperworks(rootStore.token, this.id)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.log('[DEBUG] error', error_2.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, entities.map(function (photo) { return ({
                            id: photo.id,
                            src: photo.photo.fullSize,
                            thumbnail: photo.photo.thumbnail || '',
                            width: photo.width || 0,
                            height: photo.height || 0,
                            rotate: photo.rotate || 0,
                        }); })];
                }
            });
        });
        _this.updateStatus = (0, mobx_keystone_1._async)(function (transitions) {
            var rootStore, t, entities, error_, t_1, t_1_1, transition, error_3, e_1_1;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/];
                        t = (0, lodash_1.isArray)(transitions) ? transitions : [transitions];
                        entities = undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        t_1 = __values(t), t_1_1 = t_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!t_1_1.done) return [3 /*break*/, 7];
                        transition = t_1_1.value;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, api.updateLoadStatus(rootStore.token, this.id, transition.fn, transition.params)];
                    case 4:
                        (entities = (_b.sent()).response.entities);
                        return [3 /*break*/, 6];
                    case 5:
                        error_3 = _b.sent();
                        console.log('[DEBUG] error', error_3.message);
                        error_ = (0, models_1.getError)(error_3);
                        return [3 /*break*/, 7];
                    case 6:
                        t_1_1 = t_1.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (t_1_1 && !t_1_1.done && (_a = t_1.return)) _a.call(t_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        if (entities) {
                            rootStore.setOrderLegs(entities);
                        }
                        return [2 /*return*/, error_ || (0, models_1.getSuccess)()];
                }
            });
        });
        _this.updateETAs = (0, mobx_keystone_1._async)(function (force) {
            var rootStore, currentGPSPosition, fn, entities, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore)
                            return [2 /*return*/];
                        currentGPSPosition = this.currentGPSPosition;
                        if (!(force || currentGPSPosition)) return [3 /*break*/, 5];
                        fn = void 0;
                        if (rootStore.token) {
                            fn = api.fetchLoadETA(rootStore.token, this.id, currentGPSPosition);
                        }
                        else {
                            fn = api.fetchLegETAByLinkId(rootStore.token, this.orderLegLinkId, currentGPSPosition);
                        }
                        entities = void 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fn];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.log('[DEBUG][Load.updateETAs] error', error_4);
                        return [2 /*return*/];
                    case 4:
                        if (entities) {
                            this.etas = entities;
                        }
                        _a.label = 5;
                    case 5:
                        if (!currentGPSPosition) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.checkNearbyDeparted()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
        _this.checkNearbyDeparted = (0, mobx_keystone_1._async)(function () {
            var rootStore, currentCoordinatesJson, distance, duration, arriveTransition, nearbyTransition, notified;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore)
                            return [2 /*return*/];
                        if (!this.etas || !this.etas.pickupEta || !this.etas.dropoffEta)
                            return [2 /*return*/];
                        if (!this.currentCoordinatesJson)
                            return [2 /*return*/];
                        currentCoordinatesJson = this.currentCoordinatesJson;
                        distance = this.etas.pickupEta.distance;
                        duration = moment_1.default.duration(this.etas.pickupEta.duration);
                        arriveTransition = { fn: load_1.LOAD_TRANSITION.PICKUP_ARRIVE };
                        nearbyTransition = {
                            fn: load_1.LOAD_TRANSITION.PICKUP_NEARBY,
                            params: { currentPosition: currentCoordinatesJson },
                        };
                        notified = this.pickupNearbyNotified;
                        if (this.status === load_1.LOAD_STATUS.DROPOFF_GOING) {
                            distance = this.etas.dropoffEta.distance;
                            duration = moment_1.default.duration(this.etas.dropoffEta.duration);
                            arriveTransition = { fn: load_1.LOAD_TRANSITION.DROPOFF_ARRIVE };
                            nearbyTransition = {
                                fn: load_1.LOAD_TRANSITION.DROPOFF_NEARBY,
                                params: { currentPosition: currentCoordinatesJson },
                            };
                            notified = this.dropoffNearbyNotified;
                        }
                        console.log('[DEBUG][Load.checkNearbyDeparted]', {
                            LOAD_NEARBY_THRESHOLD: load_1.LOAD_NEARBY_THRESHOLD,
                            LOAD_ARRIVED_THRESHOLD: load_1.LOAD_ARRIVED_THRESHOLD,
                            LOAD_DEPARTED_THRESHOLD: load_1.LOAD_DEPARTED_THRESHOLD,
                            load: this.id,
                            status: this.status,
                            distance: distance,
                            duration: duration,
                            arriveTransition: arriveTransition,
                            nearbyTransition: nearbyTransition,
                            notified: notified,
                        });
                        if (!(this.status === load_1.LOAD_STATUS.PICKUP_GOING ||
                            this.status === load_1.LOAD_STATUS.DROPOFF_GOING)) return [3 /*break*/, 4];
                        if (!(duration <= load_1.LOAD_ARRIVED_THRESHOLD)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateStatus(arriveTransition)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        if (!(duration <= load_1.LOAD_NEARBY_THRESHOLD && !notified)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.updateStatus(nearbyTransition)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
        return _this;
    }
    OrderLeg_1 = OrderLeg;
    Object.defineProperty(OrderLeg.prototype, "statusEta", {
        get: function () {
            return this.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "currentCoordinatesJson", {
        get: function () {
            var currentGPSPosition = this.currentGPSPosition;
            if (currentGPSPosition) {
                return {
                    type: 'Point',
                    coordinates: [
                        currentGPSPosition.longitude,
                        currentGPSPosition.latitude,
                    ],
                };
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    OrderLeg.prototype.setCurrentGPSPosition = function (position) {
        this.currentGPSPosition = position;
    };
    OrderLeg.prototype.addPositionKeyToFirebase = function (key) {
        firebase_1.default.db.ref("loads/".concat(this.id, "/positions/").concat(key)).set(true);
    };
    OrderLeg.prototype.setReport = function (value) {
        this.report = value;
    };
    OrderLeg.prototype.update = function (data, forceUpdate) {
        var _this = this;
        var rootStore = (0, mobx_keystone_1.getRootStore)(this);
        if (!rootStore) {
            return;
        }
        var result = OrderLeg_1._formatData(rootStore, data);
        if (result) {
            var orderLeg = result.orderLeg, documents = result.documents;
            Object.assign(this, orderLeg);
            if (documents) {
                var oldDocuments_1 = Array.from(this.documents);
                documents.forEach(function (document) {
                    var oldDocument = oldDocuments_1.find(function (d) { return d.id === document.id; });
                    if (oldDocument) {
                        Object.assign(oldDocument, document);
                    }
                    else {
                        _this.documents.add(new LoadDocument_1.LoadDocument(document));
                    }
                });
            }
        }
    };
    Object.defineProperty(OrderLeg.prototype, "transitions", {
        get: function () {
            return (0, load_1.getTransitions)(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "isPending", {
        get: function () {
            return this.status === load_1.LOAD_STATUS.PENDING_ACCEPTANCE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "isAssigned", {
        get: function () {
            return this.status === load_1.LOAD_STATUS.PICKUP_ACCEPTED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "isActive", {
        get: function () {
            return load_1.ACTIVE_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "isTracking", {
        get: function () {
            return load_1.TRACKING_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "pickupWindow", {
        get: function () {
            return this.pickup.isValid && this.pickup.current.pickupWindow
                ? this.pickup.current.pickupWindow
                : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "pickupLocation", {
        get: function () {
            return this.pickup.isValid ? this.pickup.current.location : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "dropoffWindow", {
        get: function () {
            return this.dropoff.isValid && this.dropoff.current.dropoffWindow
                ? this.dropoff.current.dropoffWindow
                : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "dropoffLocation", {
        get: function () {
            return this.dropoff.isValid ? this.dropoff.current.location : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "shipper", {
        get: function () {
            return this.pickup.isValid ? this.pickup.current.contact : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "receiver", {
        get: function () {
            return this.dropoff.isValid ? this.dropoff.current.contact : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "dispatcher", {
        get: function () {
            return this.order.isValid ? this.order.current.dispatcher : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "displayStatus", {
        get: function () {
            return (0, load_1.getDisplayStatus)(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "billOfLadingNumber", {
        get: function () {
            var billOfLadingNumber = this.order.isValid && this.order.current.manifest.isValid
                ? this.order.current.manifest.current.billOfLadingNumber
                : '';
            return billOfLadingNumber;
        },
        enumerable: false,
        configurable: true
    });
    OrderLeg.prototype.pickupOnTimeStatus = function (now) {
        var time = now ? now : (0, moment_1.default)();
        var eta;
        var checkin;
        var windowStart;
        var windowEnd;
        switch (this.status) {
            case load_1.LOAD_STATUS.UNASSIGNED:
            case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
            case load_1.LOAD_STATUS.ASSIGNED:
            case load_1.LOAD_STATUS.DECLINED:
            case load_1.LOAD_STATUS.ACTIVE:
                return load_1.ON_TIME_STATUS.PROCESSING;
            case load_1.LOAD_STATUS.DELIVERED:
                return load_1.ON_TIME_STATUS.DELIVERED;
            case load_1.LOAD_STATUS.COMPLETED:
                return load_1.ON_TIME_STATUS.COMPLETED;
        }
        if (!this.etas || !this.etas.pickupEta || !this.pickupWindow) {
            return load_1.ON_TIME_STATUS.UNKNOWN;
        }
        switch (this.status) {
            case load_1.LOAD_STATUS.PICKUP_ACCEPTED:
            case load_1.LOAD_STATUS.PICKUP_GOING:
                eta = (0, moment_1.default)(this.etas.pickupEta.eta);
                windowStart = (0, moment_1.default)(this.pickupWindow.lower);
                windowEnd = (0, moment_1.default)(this.pickupWindow.upper);
                if (time > windowEnd) {
                    return load_1.ON_TIME_STATUS.PICKUP_MISSED;
                }
                else if (eta < windowStart) {
                    return load_1.ON_TIME_STATUS.PICKUP_EARLY;
                }
                else if (eta > windowEnd) {
                    return load_1.ON_TIME_STATUS.PICKUP_AT_RISK;
                }
                return load_1.ON_TIME_STATUS.PICKUP_ON_TIME;
            case load_1.LOAD_STATUS.PICKUP_ARRIVED:
                return load_1.ON_TIME_STATUS.PICKUP_ARRIVED;
            case load_1.LOAD_STATUS.PICKUP_CHECKIN:
                checkin = (0, moment_1.default)(this.pickupCheckedinOn);
                if (time.diff(checkin, 'minutes') > 120) {
                    return load_1.ON_TIME_STATUS.PICKUP_DETENTION;
                }
                return load_1.ON_TIME_STATUS.PICKUP_CHECKEDIN;
            default:
                return load_1.ON_TIME_STATUS.PICKED_UP;
        }
    };
    OrderLeg.prototype.dropoffOnTimeStatus = function (now) {
        var time = now ? now : (0, moment_1.default)();
        var eta;
        var checkin;
        var windowStart;
        var windowEnd;
        switch (this.status) {
            case load_1.LOAD_STATUS.UNASSIGNED:
            case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
            case load_1.LOAD_STATUS.ASSIGNED:
            case load_1.LOAD_STATUS.DECLINED:
            case load_1.LOAD_STATUS.ACTIVE:
                return load_1.ON_TIME_STATUS.PROCESSING;
            case load_1.LOAD_STATUS.DELIVERED:
                return load_1.ON_TIME_STATUS.DELIVERED;
            case load_1.LOAD_STATUS.COMPLETED:
                return load_1.ON_TIME_STATUS.COMPLETED;
        }
        if (!this.etas || !this.etas.dropoffEta || !this.dropoffWindow) {
            return load_1.ON_TIME_STATUS.UNKNOWN;
        }
        switch (this.status) {
            case load_1.LOAD_STATUS.PICKUP_GOING:
            case load_1.LOAD_STATUS.PICKUP_ARRIVED:
            case load_1.LOAD_STATUS.PICKUP_CHECKIN:
            case load_1.LOAD_STATUS.DROPOFF_ACCEPTED:
            case load_1.LOAD_STATUS.DROPOFF_GOING:
                eta = (0, moment_1.default)(this.etas.dropoffEta.eta);
                windowStart = (0, moment_1.default)(this.dropoffWindow.lower);
                windowEnd = (0, moment_1.default)(this.dropoffWindow.upper);
                if (time > windowEnd) {
                    return load_1.ON_TIME_STATUS.DROPOFF_MISSED;
                }
                else if (eta < windowStart) {
                    return load_1.ON_TIME_STATUS.DROPOFF_EARLY;
                }
                else if (eta > windowEnd) {
                    return load_1.ON_TIME_STATUS.DROPOFF_AT_RISK;
                }
                return load_1.ON_TIME_STATUS.DROPOFF_ON_TIME;
            case load_1.LOAD_STATUS.DROPOFF_ARRIVED:
                return load_1.ON_TIME_STATUS.DROPOFF_ARRIVED;
            case load_1.LOAD_STATUS.DROPOFF_CHECKIN:
                checkin = (0, moment_1.default)(this.dropoffCheckedinOn);
                if (time.diff(checkin, 'minutes') > 120) {
                    return load_1.ON_TIME_STATUS.DROPOFF_DETENTION;
                }
                return load_1.ON_TIME_STATUS.DROPOFF_CHECKEDIN;
            default:
                return load_1.ON_TIME_STATUS.COMPLETED;
        }
    };
    Object.defineProperty(OrderLeg.prototype, "onTimeStatus", {
        get: function () {
            var now = (0, moment_1.default)();
            switch (this.status) {
                case load_1.LOAD_STATUS.UNASSIGNED:
                case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
                case load_1.LOAD_STATUS.DECLINED:
                    return load_1.ON_TIME_STATUS.PROCESSING;
                case load_1.LOAD_STATUS.ASSIGNED:
                case load_1.LOAD_STATUS.ACTIVE:
                    return load_1.ON_TIME_STATUS.LOAD_STARTED;
                case load_1.LOAD_STATUS.DELIVERED:
                    return load_1.ON_TIME_STATUS.DELIVERED;
                case load_1.LOAD_STATUS.COMPLETED:
                    return load_1.ON_TIME_STATUS.COMPLETED;
            }
            if (!this.etas || !this.etas.pickupEta || !this.etas.dropoffEta) {
                return load_1.ON_TIME_STATUS.UNKNOWN;
            }
            switch (this.status) {
                case load_1.LOAD_STATUS.PICKUP_ACCEPTED:
                case load_1.LOAD_STATUS.PICKUP_GOING:
                case load_1.LOAD_STATUS.PICKUP_ARRIVED:
                case load_1.LOAD_STATUS.PICKUP_CHECKIN:
                    return this.pickupOnTimeStatus(now);
                case load_1.LOAD_STATUS.DROPOFF_ACCEPTED:
                case load_1.LOAD_STATUS.DROPOFF_GOING:
                case load_1.LOAD_STATUS.DROPOFF_ARRIVED:
                case load_1.LOAD_STATUS.DROPOFF_CHECKIN:
                    return this.dropoffOnTimeStatus(now);
            }
            return load_1.ON_TIME_STATUS.UNKNOWN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "pickupOnTimeChipStatus", {
        get: function () {
            var time;
            var eta;
            var windowStart = this.pickupWindow && (0, moment_1.default)(this.pickupWindow.lower);
            var windowEnd = this.pickupWindow && (0, moment_1.default)(this.pickupWindow.upper);
            if (!windowStart || !windowEnd) {
                return load_1.ON_TIME_STATUS.UNKNOWN;
            }
            switch (this.status) {
                case load_1.LOAD_STATUS.UNASSIGNED:
                case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
                case load_1.LOAD_STATUS.ASSIGNED:
                case load_1.LOAD_STATUS.DECLINED:
                case load_1.LOAD_STATUS.ACTIVE:
                case load_1.LOAD_STATUS.PICKUP_GOING:
                    if (!this.etas || !this.etas.pickupEta || !this.pickupWindow) {
                        return load_1.ON_TIME_STATUS.UNKNOWN;
                    }
                    time = (0, moment_1.default)();
                    eta = (0, moment_1.default)(this.etas.pickupEta.eta);
                    if (time > windowEnd || eta > windowEnd) {
                        return load_1.ON_TIME_STATUS.PICKUP_MISSED;
                    }
                    else if (eta < windowStart) {
                        return load_1.ON_TIME_STATUS.PICKUP_EARLY;
                    }
                    else if (eta > windowStart && eta < windowEnd) {
                        return load_1.ON_TIME_STATUS.PICKUP_ON_TIME;
                    }
            }
            time = (0, moment_1.default)(this.pickupArrivedOn);
            if (time > windowEnd) {
                return load_1.ON_TIME_STATUS.PICKUP_MISSED;
            }
            else if (time < windowStart) {
                return load_1.ON_TIME_STATUS.PICKUP_EARLY;
            }
            else if (time > windowStart && time < windowEnd) {
                return load_1.ON_TIME_STATUS.PICKUP_ON_TIME;
            }
            return load_1.ON_TIME_STATUS.UNKNOWN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "dropoffOnTimeChipStatus", {
        get: function () {
            var time;
            var eta;
            var windowStart = this.dropoffWindow && (0, moment_1.default)(this.dropoffWindow.lower);
            var windowEnd = this.dropoffWindow && (0, moment_1.default)(this.dropoffWindow.upper);
            if (!windowStart || !windowEnd) {
                return load_1.ON_TIME_STATUS.UNKNOWN;
            }
            switch (this.status) {
                case load_1.LOAD_STATUS.UNASSIGNED:
                case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
                case load_1.LOAD_STATUS.ASSIGNED:
                case load_1.LOAD_STATUS.DECLINED:
                case load_1.LOAD_STATUS.ACTIVE:
                case load_1.LOAD_STATUS.DROPOFF_GOING:
                    if (!this.etas || !this.etas.dropoffEta || !this.dropoffWindow) {
                        return load_1.ON_TIME_STATUS.UNKNOWN;
                    }
                    time = (0, moment_1.default)();
                    eta = (0, moment_1.default)(this.etas.dropoffEta.eta);
                    if (time > windowEnd || eta > windowEnd) {
                        return load_1.ON_TIME_STATUS.DROPOFF_MISSED;
                    }
                    else if (eta < windowStart) {
                        return load_1.ON_TIME_STATUS.DROPOFF_EARLY;
                    }
                    else if (eta > windowStart && time < windowEnd) {
                        return load_1.ON_TIME_STATUS.DROPOFF_ON_TIME;
                    }
            }
            time = (0, moment_1.default)(this.dropoffArrivedOn);
            if (time > windowEnd) {
                return load_1.ON_TIME_STATUS.DROPOFF_MISSED;
            }
            else if (time < windowStart) {
                return load_1.ON_TIME_STATUS.DROPOFF_EARLY;
            }
            else if (time > windowStart && time < windowEnd) {
                return load_1.ON_TIME_STATUS.DROPOFF_ON_TIME;
            }
            return load_1.ON_TIME_STATUS.UNKNOWN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "trailerNumber", {
        // get billOfLadingNumber() {
        //   return this.order.isValid ? this.order.current.billOfLadingNumber : '';
        // }
        get: function () {
            return this.order.isValid ? this.order.current.trailerNumber : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadType", {
        get: function () {
            return this.order.isValid ? this.order.current.loadType : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadWeight", {
        get: function () {
            return this.order.isValid ? this.order.current.loadWeight : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadWeightUnit", {
        get: function () {
            return this.order.isValid ? this.order.current.loadWeightUnit : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadQuantity", {
        get: function () {
            return this.order.isValid ? this.order.current.loadQuantity : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadQuantityUnit", {
        get: function () {
            return this.order.isValid ? this.order.current.loadQuantityUnit : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadLength", {
        get: function () {
            return this.order.isValid ? this.order.current.loadLength : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadHeight", {
        get: function () {
            return this.order.isValid ? this.order.current.loadHeight : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadWidth", {
        get: function () {
            return this.order.isValid ? this.order.current.loadWidth : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "specialEquipment", {
        get: function () {
            return this.order.current.specialEquipment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "loadDescription", {
        get: function () {
            return this.order.isValid ? this.order.current.loadDescription : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "isPickupStatus", {
        get: function () {
            return load_1.PICKUP_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "isDropoffStatus", {
        get: function () {
            return load_1.DROPOFF_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "manifestId", {
        get: function () {
            return this.order.isValid ? this.order.current.manifestId : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "organization", {
        // get manifestNumber() {
        //   return this.order.isValid
        //     ? this.order.current.manifest.current.manifestNumber
        //     : '';
        // }
        get: function () {
            return this.order.isValid ? this.order.current.organization : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrderLeg.prototype, "currentETA", {
        get: function () {
            if (!this.etas) {
                return null;
            }
            return this.isPickupStatus ? this.etas.pickupEta : this.etas.dropoffEta;
        },
        enumerable: false,
        configurable: true
    });
    OrderLeg.prototype.setPickupHasNoDamages = function (value) {
        this.pickupHasNoDamages = value;
    };
    OrderLeg.prototype.setDropoffHasNoDamages = function (value) {
        this.dropoffHasNoDamages = value;
    };
    OrderLeg.prototype.setDriver = function (value) {
        this.driver = (0, User_1.userRef)("".concat(value));
    };
    OrderLeg.prototype.setTruck = function (value) {
        this.truck = (0, Truck_1.truckRef)("".concat(value));
    };
    OrderLeg.prototype.setDropoff = function (value) {
        this.dropoff = (0, LoadStop_1.loadStopRef)("".concat(value));
    };
    OrderLeg.prototype.setDropoffArrivedOn = function (value) {
        this.dropoffArrivedOn = value;
    };
    OrderLeg.prototype.setDropoffCheckedinOn = function (value) {
        this.dropoffCheckedinOn = value;
    };
    OrderLeg.prototype.setDropoffCompletedOn = function (value) {
        this.dropoffCompletedOn = value;
    };
    var OrderLeg_1;
    OrderLeg._formatData = function (rootStore, data) {
        var orderLeg = __assign({}, data);
        try {
            // const order = Load.create(rootStore, data.order);
            // if (order) {
            //   rootStore.loads.set(`${data.order.id}`, order);
            // }
            orderLeg.order = (0, Load_1.loadRef)("".concat(data.order));
            // const pickupStop = LoadStop.create(rootStore, data.pickup);
            // if (pickupStop) {
            //   rootStore.loadStops.set(`${data.pickup}`, pickupStop);
            // }
            orderLeg.pickup = (0, LoadStop_1.loadStopRef)("".concat(data.pickup));
            // const dropoffStop = LoadStop.create(rootStore, data.dropoff);
            // if (dropoffStop) {
            //   rootStore.loadStops.set(`${data.dropoff}`, dropoffStop);
            // }
            orderLeg.dropoff = (0, LoadStop_1.loadStopRef)("".concat(data.dropoff));
            if (data.driver) {
                if (!rootStore.users.has("".concat(data.driver))) {
                    rootStore.fetchUser(data.driver);
                }
                orderLeg.driver = (0, User_1.userRef)("".concat(data.driver));
            }
            else {
                orderLeg.driver = null;
            }
            if (data.truck) {
                if (!rootStore.trucks.has("".concat(data.truck))) {
                    rootStore.fetchTruck(data.truck);
                }
                orderLeg.truck = (0, Truck_1.truckRef)("".concat(data.truck));
            }
            else {
                orderLeg.truck = null;
            }
            delete orderLeg.documents;
            return {
                orderLeg: orderLeg,
                documents: data.documents,
            };
        }
        catch (error) {
            console.warn('[WARN] error', error);
            return null;
        }
    };
    OrderLeg.create = function (rootStore, data) {
        var result = OrderLeg_1._formatData(rootStore, data);
        if (result) {
            var orderLeg = result.orderLeg, documents = result.documents;
            var newOrderLeg_1 = new OrderLeg_1(orderLeg);
            if (documents && documents.length > 0) {
                documents.forEach(function (document) {
                    return newOrderLeg_1.documents.add(new LoadDocument_1.LoadDocument(document));
                });
            }
            return newOrderLeg_1;
        }
        else {
            return null;
        }
    };
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "statusEta", null);
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "currentCoordinatesJson", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setCurrentGPSPosition", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "addPositionKeyToFirebase", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setReport", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "update", null);
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "onTimeStatus", null);
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "pickupOnTimeChipStatus", null);
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "dropoffOnTimeChipStatus", null);
    __decorate([
        (0, models_1.asDate)('loadStartedOn')
    ], OrderLeg.prototype, "loadStartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupStartedOn')
    ], OrderLeg.prototype, "pickupStartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupArrivedOn')
    ], OrderLeg.prototype, "pickupArrivedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupCheckedinOn')
    ], OrderLeg.prototype, "pickupCheckedinOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupDepartedOn')
    ], OrderLeg.prototype, "pickupDepartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffStartedOn')
    ], OrderLeg.prototype, "dropoffStartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffArrivedOn')
    ], OrderLeg.prototype, "dropoffArrivedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffCheckedinOn')
    ], OrderLeg.prototype, "dropoffCheckedinOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffCompletedOn')
    ], OrderLeg.prototype, "dropoffCompletedOnDate", void 0);
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "isPickupStatus", null);
    __decorate([
        mobx_1.computed
    ], OrderLeg.prototype, "isDropoffStatus", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setPickupHasNoDamages", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setDropoffHasNoDamages", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setDriver", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setTruck", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setDropoff", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setDropoffArrivedOn", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setDropoffCheckedinOn", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], OrderLeg.prototype, "setDropoffCompletedOn", null);
    __decorate([
        mobx_keystone_1.modelFlow
    ], OrderLeg.prototype, "updateDwellTime", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], OrderLeg.prototype, "getAllPaperworks", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], OrderLeg.prototype, "updateStatus", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], OrderLeg.prototype, "updateETAs", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], OrderLeg.prototype, "checkNearbyDeparted", void 0);
    OrderLeg = OrderLeg_1 = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/OrderLeg')
    ], OrderLeg);
    return OrderLeg;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    order: (0, mobx_keystone_1.prop)(),
    legNumber: (0, mobx_keystone_1.prop)(),
    orderNumber: (0, mobx_keystone_1.prop)(),
    orderLegLinkId: (0, mobx_keystone_1.prop)(),
    status: (0, mobx_keystone_1.prop)(),
    dmId: (0, mobx_keystone_1.prop)(),
    baseDmId: (0, mobx_keystone_1.prop)(),
    driver: (0, mobx_keystone_1.prop)(),
    truck: (0, mobx_keystone_1.prop)(),
    pickup: (0, mobx_keystone_1.prop)(),
    dropoff: (0, mobx_keystone_1.prop)(),
    pickupInstructionsInherit: (0, mobx_keystone_1.prop)(),
    pickupInstructionsText: (0, mobx_keystone_1.prop)(),
    pickupHasNoDamages: (0, mobx_keystone_1.prop)(),
    dropoffInstructionsInherit: (0, mobx_keystone_1.prop)(),
    dropoffInstructionsText: (0, mobx_keystone_1.prop)(),
    dropoffHasNoDamages: (0, mobx_keystone_1.prop)(),
    pickupStartedOn: (0, mobx_keystone_1.prop)(),
    pickupNearbyNotified: (0, mobx_keystone_1.prop)(false),
    pickupArrivedOn: (0, mobx_keystone_1.prop)(),
    pickupCheckedinOn: (0, mobx_keystone_1.prop)(),
    pickupDepartedOn: (0, mobx_keystone_1.prop)(),
    pickupInstructions: (0, mobx_keystone_1.prop)(),
    dropoffNearbyNotified: (0, mobx_keystone_1.prop)(false),
    dropoffStartedOn: (0, mobx_keystone_1.prop)(),
    dropoffArrivedOn: (0, mobx_keystone_1.prop)(),
    dropoffCheckedinOn: (0, mobx_keystone_1.prop)(),
    dropoffCompletedOn: (0, mobx_keystone_1.prop)(),
    pickupArrivedOnDwell: (0, mobx_keystone_1.prop)(),
    pickupDepartedOnDwell: (0, mobx_keystone_1.prop)(),
    dropoffArrivedOnDwell: (0, mobx_keystone_1.prop)(),
    dropoffDepartedOnDwell: (0, mobx_keystone_1.prop)(),
    dropoffInstructions: (0, mobx_keystone_1.prop)(),
    loadStartedOn: (0, mobx_keystone_1.prop)(),
    pickupNumber: (0, mobx_keystone_1.prop)(),
    documents: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
    etas: (0, mobx_keystone_1.prop)(),
    currentGPSPosition: (0, mobx_keystone_1.prop)(),
    linkedLegCount: (0, mobx_keystone_1.prop)(),
    splitLegCount: (0, mobx_keystone_1.prop)(1),
    isMultiLeg: (0, mobx_keystone_1.prop)(false),
    isMultiOrder: (0, mobx_keystone_1.prop)(false),
    orderCount: (0, mobx_keystone_1.prop)(1),
    report: (0, mobx_keystone_1.prop)(),
    skipPickupPhotos: (0, mobx_keystone_1.prop)(false),
    skipDropoffPhotos: (0, mobx_keystone_1.prop)(false),
    skipBolDocument: (0, mobx_keystone_1.prop)(false),
    skipTripSheetDocument: (0, mobx_keystone_1.prop)(false),
})));
exports.OrderLeg = OrderLeg;
exports.orderLegRef = (0, mobx_keystone_1.rootRef)('doc-mate/OrderLegRef', {
    getId: function (target) {
        if (target instanceof OrderLeg) {
            return "".concat(target.id);
        }
    },
});
